/** z-index muy alto para flotar sobre cualquier UI del cliente sin tapar dev tools. */
export const GUIDE_Z_INDEX = 2147483640;

/** Tiempo máximo esperando que aparezca el elemento ancla de un tooltip. */
export const DEFAULT_ANCHOR_WAIT_MS = 5000;

/** Protocolos permitidos en `imageUrl` y `style.ctaUrl`. */
export const SAFE_URL_PROTOCOLS: ReadonlyArray<string> = ['http:', 'https:'];

/** Atributo data-* que marca un host de guía en el DOM (útil para tests). */
export const GUIDE_HOST_ATTR = 'data-veo-guide';

/**
 * Prefijo del key de localStorage donde vive el cache de frequency.
 * Se completa con un identificador derivado del apiKey para evitar
 * contaminación cuando el mismo navegador corre varios workspaces.
 */
export const FREQUENCY_CACHE_KEY_PREFIX = 'veo:freq:';

/** Tiempo entre flushes automáticos del tracker (ms). */
export const DEFAULT_TRACKER_FLUSH_INTERVAL_MS = 3000;

/** Cuántas interactions se acumulan antes de un flush forzado. */
export const DEFAULT_TRACKER_BATCH_SIZE = 5;

/** Reintentos por item antes de descartar (se aplica con backoff implícito por el timer). */
export const DEFAULT_TRACKER_MAX_RETRIES = 3;

/** Límite de entradas en el cache local — protege contra bloat de localStorage. */
export const FREQUENCY_CACHE_MAX_ENTRIES = 500;

/** TTL para entradas del cache. Tras esto se vuelven a re-evaluar contra el backend. */
export const FREQUENCY_CACHE_TTL_MS = 90 * 24 * 60 * 60 * 1000;

/**
 * Prefijo del key de localStorage donde vive el estado del walkthrough
 * activo. Se completa con el mismo `namespaceFromApiKey` que el frequency
 * cache para que dos workspaces en el mismo navegador no se pisen.
 */
export const WALKTHROUGH_STATE_KEY_PREFIX = 'veo:walkthrough_state:';

/**
 * Si pasan 30 min sin progreso (`advance`/`back`), el walkthrough se
 * considera abandonado. El estado se limpia de localStorage al detectarlo
 * y NO se envía `completed` al backend (porque no se completó).
 */
export const WALKTHROUGH_ABANDONMENT_TIMEOUT_MS = 30 * 60 * 1000;

/**
 * Tiempo máximo esperando que aparezca el selector del step actual en el
 * DOM. Más restrictivo que `DEFAULT_ANCHOR_WAIT_MS` porque en walkthroughs
 * la página correcta debería estar ya cargada al resumir.
 */
export const WALKTHROUGH_STEP_SELECTOR_TIMEOUT_MS = 5000;
